import { LEGAL_LOCALE, LEGAL_VERSION } from "./legalMessages";

export const JOIN_CONSENT_JURISDICTION = "ZA";
export const JOIN_CONSENT_STORAGE_KEY = "arl.joinConsent";

const joinMessages = {
  "en-ZA": {
    consentHeading: "Before you join",
    consentHelp: "Please confirm all three agreements to enable the Join Discord button.",
    rulesPrefix: "I agree to follow the ARL ",
    rulesLink: "rules and policies",
    termsPrefix: "I agree to the ",
    termsLink: "Terms of Use",
    privacyConnector: " and acknowledge the ",
    privacyLink: "Privacy Policy",
    profileDisclosure:
      "I understand that participation in league events generates official sporting records. ARL records and may publicly publish driver names/display names, team and vehicle information, qualifying results, race results, lap times, penalties, points, standings and related competition statistics. My Steam ID will also be linked to my driver profile after I complete my first race.",
    joinDiscord: "Join Discord",
  },
};

export function getJoinMessages(locale = LEGAL_LOCALE) {
  return joinMessages[locale] ?? joinMessages[LEGAL_LOCALE];
}

export function createJoinConsentRecord(consents, acceptedAt = new Date().toISOString()) {
  return {
    acceptedAt,
    locale: LEGAL_LOCALE,
    jurisdiction: JOIN_CONSENT_JURISDICTION,
    legalVersion: LEGAL_VERSION,
    consents: { ...consents },
  };
}
